import React, { useId } from 'react';
import BaseCheckboxOrRadio from '#/shared/components/BaseCheckboxOrRadio';
import type { RadioButtonProps } from '#/types/inputs';
import * as Styled from './styled';

function RadioButton({
  checked,
  label,
  onChange,
  name,
  value,
  className = undefined,
  dataGtm = undefined,
  labelPosition = 'right',
  description = undefined,
}: RadioButtonProps): React.ReactElement {
  const id = useId();
  const descriptionId = useId();

  return (
    <BaseCheckboxOrRadio
      label={label}
      className={className}
      labelPosition={labelPosition}
      id={id}
      descriptionId={descriptionId}
      description={description}
    >
      <Styled.RadioButtonInput
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={e => {
          onChange(e.target.value);
        }}
        data-gtm={dataGtm}
        aria-describedby={description && descriptionId}
      />
      {checked && <Styled.RadioSelected aria-hidden="true" />}
    </BaseCheckboxOrRadio>
  );
}

export default RadioButton;
